(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'main .shopify-section';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observedSections = new WeakSet();

    const reveal = (section) => {
      section.dataset.scrollRevealState = 'visible';
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    const prepareSection = (section, index) => {
      if (observedSections.has(section)) return;

      observedSections.add(section);

      if (index === 0 || reducedMotion.matches || section.dataset.scrollReveal === 'off') {
        reveal(section);
        return;
      }

      section.dataset.scrollRevealState = 'pending';
      observer.observe(section);
    };

    const preparePage = () => {
      document.documentElement.classList.add('scroll-reveal-enabled');
      document.querySelectorAll(selector).forEach(prepareSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preparePage, { once: true });
    } else {
      preparePage();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const sections = Array.from(document.querySelectorAll(selector));
      const section = event.target.closest('.shopify-section') || event.target.querySelector('.shopify-section');

      if (section) prepareSection(section, sections.indexOf(section));
    });

    reducedMotion.addEventListener('change', () => {
      if (!reducedMotion.matches) return;

      document.querySelectorAll(`${selector}[data-scroll-reveal-state='pending']`).forEach((section) => {
        reveal(section);
        observer.unobserve(section);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["havnby-market-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.querySelector('[data-hvn-market-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    const closeButton = modal.querySelector('[data-hvn-market-close]');
    const localeInput = modal.querySelector('[data-hvn-locale-input]');
    const languageButtons = [...modal.querySelectorAll('[data-hvn-locale]')];
    const languageLabels = [...modal.querySelectorAll('[data-hvn-selected-language]')];
    const triggers = [...document.querySelectorAll('button[aria-label*="Change country or currency"]')];
    const currencyCode = modal.dataset.currentCurrency;
    const languageCode = modal.dataset.currentLanguage;

    triggers.forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'HvnMarketModal');

      const content = trigger.querySelector('.h-stack');
      if (content) {
        content.innerHTML = `
          <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M3 12h18M12 3c2.4 2.5 3.6 5.5 3.6 9S14.4 18.5 12 21M12 3C9.6 5.5 8.4 8.5 8.4 12S9.6 18.5 12 21"></path>
          </svg>
          <span class="bold text-sm">${currencyCode}/${languageCode}</span>
        `;
      }

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      }, true);
    });

    languageButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const languageName = button.textContent.trim();
        localeInput.value = button.dataset.hvnLocale;
        languageButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        languageLabels.forEach((label) => { label.textContent = languageName; });
      });
    });

    const closeModal = () => modal.close();
    closeButton?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener('close', () => {
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-install-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-install-video')) {
    customElements.define(
      'variant-install-video',
      class VariantInstallVideo extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.mediaContainer = this.querySelector('.variant-install-video__media');
          this.trigger = this.querySelector('.variant-install-video__trigger');
          this.closeButton = this.querySelector('.variant-install-video__close');
          this.scope = this.closest('section') || document;
          this.activeVariantId = this.dataset.initialVariantId;
          this.handleOptionChange = () => requestAnimationFrame(() => this.syncVariant());

          this.trigger.addEventListener('click', () => this.open());
          this.closeButton.addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => this.unloadVideo());
          this.scope.addEventListener('change', this.handleOptionChange);

          this.syncVariant();
        }

        disconnectedCallback() {
          this.scope?.removeEventListener('change', this.handleOptionChange);
        }

        getSelectedVariantId() {
          const variantInput = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          return variantInput?.value || this.activeVariantId;
        }

        getTemplate(variantId) {
          return Array.from(this.querySelectorAll('template[data-video-template]')).find(
            (template) => template.dataset.variantId === String(variantId)
          );
        }

        syncVariant() {
          const nextVariantId = this.getSelectedVariantId();
          if (nextVariantId === this.activeVariantId && !this.hidden) return;

          this.activeVariantId = nextVariantId;
          const template = this.getTemplate(nextVariantId);
          this.hidden = !template;

          if (this.dialog.open) this.dialog.close();
        }

        open() {
          const template = this.getTemplate(this.activeVariantId);
          if (!template) return;

          this.mediaContainer.replaceChildren(template.content.cloneNode(true));
          this.dialog.showModal();

          const video = this.mediaContainer.querySelector('video');
          if (video) video.play().catch(() => {});
        }

        unloadVideo() {
          const video = this.mediaContainer.querySelector('video');
          if (video) video.pause();
          this.mediaContainer.replaceChildren();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
